import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import { origin } from '../../config';
import { translate } from '../../utils/locale';
import s from './Share.scss';

const nullFunction = () => {};

const Share = ({ setup, link, viewLinkHandler = nullFunction, view = false }) => {
	const [copied, toggleCopied] = useState(false);

	const shareLinkHandler = (e) => {
		e.preventDefault();
		const text = e.currentTarget.getAttribute('href');

		window.navigator.clipboard.writeText(text).then((t) => {
			toggleCopied(true);

			setTimeout(() => {
				toggleCopied(false);
			}, 3000);

			return t;
		}).catch((err) => {
			console.error('DEBUG: Could not copy text: ', err);
		});
	};

	return (
		<div className={s.share}>
			<h6 className={s.share_title}>{ translate(setup, 'shareTitle') }</h6>
			<a className={s.share_link} href={`mailto:?subject=${encodeURIComponent(translate(setup, 'shareEmailSubject'))}&body=${encodeURIComponent(translate(setup, 'shareBody').replace('%link%', `${origin}${link}`))}`}><span>{ translate(setup, 'shareEmail') }</span></a>
			<a className={s.share_link} href={`${typeof document !== 'undefined' && /(Mac)/i.test(window.navigator.platform) ? 'imessage' : 'sms'}:&body=${encodeURIComponent(translate(setup, 'shareBody').replace('%link%', `${origin}${link}`))}`}><span>{ translate(setup, 'shareMessage') }</span></a>
			<a className={s.share_link} href={`http://www.facebook.com/sharer.php?u=${encodeURIComponent(`${origin}${link}`)}&t=${encodeURIComponent(translate(setup, 'shareBody').replace('%link%', link))}`} rel="noopener noreferrer nofollow" target="_blank"><span>{ translate(setup, 'shareFacebook') }</span></a>
			<Link className={s.share_link} to={`${origin}${link}`} onClick={shareLinkHandler}><span>{ copied ? translate(setup, 'shareCopiedLink') : translate(setup, 'shareCopyLink') }</span></Link>
			{ view && <Link className={s.share_link} to={link} onClick={viewLinkHandler}><span>{ translate(setup, 'shareViewLink') }</span></Link> }
		</div>
	);
};

export default hot(module)(Share);
